module.exports = __webpack_public_path__ + "img/youshi.d7d6421d.png";